const checkSubscription = (expiryDate) => {
  const todaysDate = new Date();
  const newExpiryDate = new Date(expiryDate);
  if (newExpiryDate > todaysDate) {
    return true;
  }
  return false;
}

export default checkSubscription;